<tlk-card class="notes-list-card" id="notes-section" data-testid="notes-section">
	<h3 tlkCardHeader class="notes-list-title tlk-typo-title_size_m">
		{{ 'NotesSection.Notes' | translate }}
	</h3>
	<div tlkCardContent class="notes-list-body">
		<ng-container *ngIf="notesPanelVm$ | async as panel">
			<div *ngIf="panel.notes.length === 0" class="notes-empty-state">
				<div class="empty-state-icon" aria-hidden="true">
					<tlk-new-message-icon class="empty-state-icon-svg tlk-icon_size_l"></tlk-new-message-icon>
				</div>
				<div class="empty-state-text">
					<div class="empty-state-title tlk-typo-label tlk-typo-label_size_m">{{ 'NotesSection.NoNotesYet' | translate }}</div>
					<div *ngIf="panel.canDelete" class="empty-state-subtitle tlk-typo-label tlk-typo-label_size_m">
						{{ 'NotesSection.TypeBelowHint' | translate }}
					</div>
				</div>
			</div>
			<div
				*ngIf="panel.notes.length > 0"
				class="notes-scroll-list"
				[class.notes-scroll-list--read-only]="!panel.canDelete"
			>
				<rx-note-card
					*ngFor="let note of panel.notes; trackBy: trackByNote"
					[note]="note"
					[dateFormat]="dateFormat$ | async"
					[relativeTimeRefreshTick]="relativeTimeRefreshTick$ | async"
					[isEditing]="editingNoteId === note.id"
					[canDelete]="panel.canDelete && note.canModify"
					[isClickable]="panel.canDelete && note.canModify"
					[isPrintContext]="false"
					(edit)="handleEdit(note.id, $event)"
					(editModeChange)="handleEditModeChange(note.id, $event)"
					(remove)="handleRemove(note.id)"
				/>
			</div>
		</ng-container>
		<div *ngIf="showAddComposer$ | async" class="notes-add-row">
			<div class="notes-input-wrapper">
				<rx-textarea
					[formControl]="newNote"
					[rows]="2"
					[placeholder]="'NotesSection.InputPlaceholder' | translate"
					(submitted)="onNewNoteSubmitted($event)"
					class="notes-input-textarea"
				>
					<button
						rxTextareaSubmit
						matSuffix
						tlkButton
						variant="primary"
						size="l"
						type="button"
						class="send-note-button"
						data-testid="notes-send"
						[disabled]="isSendNoteButtonDisabled"
						[attr.aria-label]="'NotesSection.Send' | translate"
					>
						<tlk-send-outline-icon></tlk-send-outline-icon>
					</button>
				</rx-textarea>
			</div>
		</div>
	</div>
</tlk-card>
